import React, { useCallback, useEffect, useState } from "react";
import { convertToOptionsList, formatCNPJ } from "../../utils";
import { useDistributor } from "../../contexts/distributor/DistributorContext";
import MultipleSelectCheckbox from "../MultipleSelectCheckbox";

interface SelectDistributorsProps {
  label?: string;
  maxWidth?: number;
  clearSelection?: boolean;
}

const MultipleSelectDistributors: React.FC<SelectDistributorsProps> = ({
  label = "",
  maxWidth,
  clearSelection = false,
}) => {
  const { distributors, setSelectedDistributorsStoraged } = useDistributor();

  const [codeDistributors, setCodeDistributors] = useState<string[]>([]);

  useEffect(() => {
    if (distributors.length > 0) {
      const storedValue = localStorage.getItem("multipleSelectedDistributor");
      if (storedValue) {
        const parsed = JSON.parse(storedValue);
        setCodeDistributors(parsed);
        setSelectedDistributorsStoraged(parsed);
      } else {
        const allIds = distributors.map((ele) => ele.id as string);
        setCodeDistributors(allIds);
        setSelectedDistributorsStoraged(allIds);
      }
    }
  }, [distributors]);

  useEffect(() => {
    if (clearSelection) {
      const allIds = distributors.map((ele) => ele.id as string);
      setCodeDistributors(allIds);
      setSelectedDistributorsStoraged(allIds);
      localStorage.removeItem("multipleSelectedDistributor");
    }
  }, [clearSelection, distributors]);

  const handleChangeSelectedDistributors = useCallback(
    (event: string[]) => {
      setCodeDistributors(event);
      setSelectedDistributorsStoraged(event);
      localStorage.setItem(
        "multipleSelectedDistributor",
        JSON.stringify(event)
      );
    },
    [setSelectedDistributorsStoraged]
  );

  const distributorsCustom = distributors.map((ele) => ({
    ...ele,
    description: `${ele.description} - ${formatCNPJ(ele.document) ?? ""}`,
  }));

  return (
    <>
      <MultipleSelectCheckbox
        label={label}
        maxWidth={maxWidth ?? 350}
        options={convertToOptionsList(distributorsCustom, "id", "description")}
        value={codeDistributors}
        onChange={handleChangeSelectedDistributors}
      />
    </>
  );
};

export default MultipleSelectDistributors;
